import api from "./api";

export const roleService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/roles", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/roles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(roleData) {
    try {
      const response = await api.post("/roles", roleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, roleData) {
    try {
      const response = await api.put(`/roles/${id}`, roleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/roles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async toggleStatus(id) {
    try {
      const response = await api.patch(`/roles/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getStats() {
    try {
      const response = await api.get("/roles/stats");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default roleService;
